module.exports = __webpack_public_path__ + "static/media/structuretone.cd87989d.png";